var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1335.2,4336c-244.2-30.4-473.8-166.6-614.2-363.7c-178.2-248.4-218-567-108-852.1c84.9-221.2,290.3-423.4,515.7-508.4 c160.4-59.7,367.9-72.3,531.4-30.4c161.4,40.8,328.1,141.5,442.3,266.2c371,406.7,289.3,1048.2-171.9,1349 C1757.6,4309.8,1536.4,4361.2,1335.2,4336z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3345,4724.2c-271-33.8-525.9-184.9-681.7-403.7c-197.8-275.7-241.9-629.4-119.8-945.8c94.2-245.5,322.2-470,572.4-564.3 c178-66.3,408.4-80.3,589.8-33.8c179.2,45.3,364.1,157,490.9,295.5c411.8,451.4,321,1163.4-190.8,1497.2 C3813.8,4695.1,3568.3,4752.1,3345,4724.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1207.3,2322.5c-580.6-67-1032.4-524.1-1097.4-1113.2c-14.6-131-14.6-216.9,1.1-277.7c16.8-67.1,90.2-140.4,157.2-157.3 c34.6-9.4,220.1-12.6,632.1-12.6c550.3,0,582.7,1.1,577.5,18.9c-34.6,118.5-40.8,201.2-27.3,350.1 c36.7,410.9,203.3,790.3,470.6,1069.2c25.1,27.3,45.1,52.4,41.9,54.5c-12.6,13.6-212.8,58.7-297.6,69.2 C1554.2,2336.1,1321.5,2335.2,1207.3,2322.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3122.2,2492c-394.1-53.8-733.7-297.6-965.3-692.1c-159.3-270.6-266.2-670.6-266.2-997.8c0-122.5,37.8-216.8,110.1-274.7 l50.3-40.3l1379.4-4.1c1558.6-4.1,1454.8-10.8,1529.3,98.3c58.7,86.1,70.2,153.6,55.6,339.3c-26.2,334-109,615.4-256.8,872.5 c-198.1,343.4-477.9,575.1-811.3,667.9c-90.2,25.6-141.5,28.3-442.3,32.3C3317.2,2494.8,3145.3,2494.8,3122.2,2492z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.9109b3f771e4352ebb2bfb6fe518508d.svg";
export { ForwardRef as ReactComponent };